import React from 'react';
import { AffordanceHandleIndicator } from '@/components/bottom-sheet-backdrop';
import { createStyles } from '@/contexts/theme-context';
import { View } from 'react-native';

interface Props {
  hasIssues: boolean;
  progress: number;
}

export const OrderCheckInHandleWithProgress: React.FC<Props> = ({
  hasIssues,
  progress,
}) => {
  const [styles, theme] = useStyles();
  return (
    <View style={styles.container}>
      <View style={styles.progressTrack}>
        <View
          style={[
            styles.progressBar,
            {
              backgroundColor: hasIssues
                ? theme.sk.color.icon.warning.secondary
                : theme.sk.color.bg.highlight.primary,
              width: `${progress}%`,
            },
          ]}
        />
      </View>
      <AffordanceHandleIndicator />
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    backgroundColor: theme.colors.white,
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    overflow: 'hidden',
  },
  progressBar: {
    height: '100%',
  },
  progressTrack: {
    backgroundColor: theme.sk.color.bg.secondary.hover,
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    height: 3,
    overflow: 'hidden',
  },
}));
